import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "has-text-primary"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_NavbarAvatar = _resolveComponent("NavbarAvatar");

  var _component_el_dropdown_item = _resolveComponent("el-dropdown-item");

  var _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");

  var _component_el_dropdown = _resolveComponent("el-dropdown");

  return _openBlock(), _createBlock(_component_el_dropdown, {
    trigger: "click",
    "data-cy": "navbar-main-menu"
  }, {
    dropdown: _withCtx(function () {
      return [_createVNode(_component_el_dropdown_menu, null, {
        default: _withCtx(function () {
          return [_createVNode(_component_NavbarAvatar, {
            avatarWithLink: true
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", {
                class: "has-text-primary has-cursor",
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return _ctx.toggleModalVisible(_ctx.ModalStatus.Preferences);
                }),
                "data-cy": "preferences-button"
              }, _toDisplayString(_ctx.$t("preferences.title")), 1)];
            }),
            _: 1
          }), _ctx.hasCustomerDisplay ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 0,
            divided: "",
            onClick: _cache[1] || (_cache[1] = function ($event) {
              return _ctx.isCustomerDisplayOpened ? _ctx.closeCustomerDisplay() : _ctx.openCustomerDisplay();
            }),
            "data-cy": "toggle-customer-display-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.isCustomerDisplayOpened ? "Close Customer Display" : "Open Customer Display"), 1)];
            }),
            _: 1
          })) : _createCommentVNode("", true), !_ctx.hasSalesStarted ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 1,
            divided: "",
            onClick: _cache[2] || (_cache[2] = function ($event) {
              return _ctx.startSales();
            }),
            "data-cy": "start-sales-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("nav.open-sales")), 1)];
            }),
            _: 1
          })) : _createCommentVNode("", true), _ctx.hasSalesStarted ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 2,
            divided: "",
            onClick: _cache[3] || (_cache[3] = function ($event) {
              return _ctx.DeviceModule.isOldDeviceLogic ? _ctx.toggleModalVisible(_ctx.ModalStatus.CashFloatClose) : _ctx.CashFloatModule.setIsClosingCashfloat(true);
            }),
            "data-cy": "close-sales-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("nav.close-sales")), 1)];
            }),
            _: 1
          })) : _createCommentVNode("", true), _ctx.hasLocation && !_ctx.DeviceModule.isOldDeviceLogic && _ctx.hasSalesStarted || _ctx.isTEST ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 3,
            "data-cy": "show-cash-movements-modal",
            divided: "",
            onClick: _cache[4] || (_cache[4] = function ($event) {
              return _ctx.toggleModalVisible(_ctx.ModalStatus.CashInOut);
            })
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(" Cash In/Out ")];
            }),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_dropdown_item, {
            id: "show-settings-modal",
            divided: "",
            onClick: _cache[5] || (_cache[5] = function ($event) {
              return _ctx.toggleModalVisible(_ctx.ModalStatus.Settings);
            }),
            "data-cy": "pos-settings-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("nav.Point-of-sales-settings")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            divided: "",
            onClick: _cache[6] || (_cache[6] = function ($event) {
              return _ctx.toggleModalVisible(_ctx.ModalStatus.PosConfig);
            }),
            "data-cy": "pos-configs-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("posconfiguration.title")), 1)];
            }),
            _: 1
          }), _ctx.countryCode === 'BE' ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 4,
            divided: "",
            onClick: _cache[7] || (_cache[7] = function ($event) {
              return _ctx.toggleModalVisible(_ctx.ModalStatus.FiscalReports);
            })
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("compliance.fiscal-reports")), 1)];
            }),
            _: 1
          })) : _createCommentVNode("", true), _ctx.countryCode === 'BE' ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
            key: 5,
            divided: "",
            onClick: _cache[8] || (_cache[8] = function ($event) {
              return _ctx.exportFiscalArchive();
            })
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("compliance.export-fiscal-archive")), 1)];
            }),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_el_dropdown_item, {
            divided: "",
            onClick: _cache[9] || (_cache[9] = function ($event) {
              return _ctx.dataBackupHandler();
            }),
            "data-cy": "data-backup-button"
          }, {
            default: _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_ctx.$t("nav.data-backup")), 1)];
            }),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            divided: "",
            onClick: _cache[10] || (_cache[10] = function ($event) {
              return _ctx.onLogOut();
            }),
            "data-cy": "sign-out-button"
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t("nav.sign-out")), 1)];
            }),
            _: 1
          })];
        }),
        _: 1
      })];
    }),
    default: _withCtx(function () {
      return [_createVNode(_component_NavbarAvatar)];
    }),
    _: 1
  });
}